namespace Link.Masjid {
    
    @Serenity.Decorators.registerEditor()
    export class KategoriMasjidEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            var arrKategori = [
                "Masjid Raya",
                "Masjid Agung",
                "Masjid Besar",
                "Masjid Jami ",
                "Masjid Umum",
                "Masjid Bersejarah",
                "Masjid Kedinasan - TNI AL",
                "Masjid Kampus/Sekolah",
                "Masjid Perumahan",
                "Masjid di Mall/Pasar",
                "Masjid Pesantren",
                "Masjid Kantor",
                "Musala",
                "Masjid Kedinasan - TNI AD",
                "Masjid Kedinasan - TNI AU",
                "Masjid Mabes TNI"
            ];
            arrKategori.forEach(x => {
                this.addItem({ id: x, text: x });
            });
        }
    }
}